import { Helmet } from "react-helmet";
import { useEffect } from "react";
import ga from "../../googleAnalytics";
import "./booktime.css";
import homepagePic from "../../media/images/homepagePic.png";
import { COMPANY_NAME, EMAIL } from "../../globals";

export const BookTime = () => {
  useEffect(() => {
    //report to page view
    ga.trackPageView();
  }, []);

  return (
    <div>
      <Helmet>
        <title>${COMPANY_NAME} | Ajanvaraus</title>
        <meta
          name="description"
          property="og:description"
          content="Varaa aikasi Forma Helsinkiin täältä."
        ></meta>
        <meta property="og:title" content="Ajanvaraus" />
        <meta property="og:url" content={`${EMAIL}/booking`} />
        <meta property="og:image" content={homepagePic} />
        <meta
          name="keywords"
          content="hairdresser, parturi, Make up, salon, Helsinki, Mikonkatu, kampaamo, website, ajanvaraus, booking, tidsbokning, parturikampaamo, hår, frisörtider, barberar tidsbokning, kampaamo ajanvaraus, ajat, vapaat ajat, vapaat ajat kampaamoon, hääkampaus, meikki, häämeikki, kampaus, hiustenleikkaus"
        />
      </Helmet>
      <div id="booktime-container">
		<iframe 
			title="trima"
			width="100%"
			height="800vh"
			frameborder="0"
			src="https://varaa.timma.fi/reservation/formahelsinki"
			id="reservationIframe63683"></iframe>
      </div>
    </div>
  );
};
